import { Component, inject } from '@angular/core'
import { CalculationModuleSignature } from '@core/models/calculation-module.model'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { CMSessionService } from '@core/services/cm-session.service'
import { SelectionToolService } from '@core/services/selection-tool.service'
import Keycloak from 'keycloak-js'
import { CmListComponent } from './cm-list/cm-list.component'
import { CmSelectedComponent } from './cm-selected/cm-selected.component'

@Component({
  selector: 'app-cms-tab',
  templateUrl: 'cms-tab.component.html',
  imports: [
    // Components
    CmListComponent,
    CmSelectedComponent,
  ],
})
export class CMsTabComponent {
  readonly keycloak = inject(Keycloak)

  calculationModuleService = inject(CalculationModuleService)
  selectionToolService = inject(SelectionToolService)
  private readonly _cmSessionService = inject(CMSessionService)
  isConnected = false

  cmSelected$ = this.calculationModuleService.cmSelected$

  async ngOnInit() {
    this.isConnected = this.keycloak.authenticated ?? false
    if (this.isConnected && this._cmSessionService.cmSessions$().length === 0) {
      // init session list
      const response = await this._cmSessionService.GETlist()
      if (response) this._cmSessionService.cmSessions$.set(response)
    }
  }

  selectCM(cm: CalculationModuleSignature) {
    this.cmSelected$.set(cm)
  }

  unselectCM() {
    this.cmSelected$.set(null)
  }
}
